module.exports = __webpack_public_path__ + "static/media/1.d10b77ff.svg";